<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
				<!-- <m-search-item label="卡券编码">
					<c-input type="input" name="code"></c-input>
				</m-search-item> -->
				<m-search-item label="核销时间">
					<c-datetime start-name="start_date" end-name="end_date" type="date" range></c-datetime>
				</m-search-item>
				<m-search-item label="关联订单号">
					<c-input type="input" name="order_number"></c-input>
				</m-search-item>
                <m-search-item colspan="2">
					<c-checkbox-group name="states" :options="stateDic"></c-checkbox-group>
				</m-search-item>
            </m-search>
			
            <c-table ref="table" >
                <c-table-column
                        label="状态"
                        name="state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:dodgerblue">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 3" style="color:orange">{{stateText[data.state]}}</span>
                        <span v-if="data.state == 4" style="color:gray">{{stateText[data.state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="卡券编码"
                        name="code"
                        width="130"
                >
                </c-table-column>
				
                <c-table-column
                        label="商品信息"
                        name="product_name"
                        width="260"
                >
                    <template v-slot="{data}">
                        <product-info :image="data.product_img_url" :name="data.product_name"></product-info>
                    </template>
                </c-table-column>
				
				<c-table-column
				        label="商品规格"
				        name="product_sku_spec"
				        width="100"
				>
				</c-table-column>

                <c-table-column
                        label="关联订单号"
                        name="order_number"
                        width="120"
                >
					<template v-slot="{data}">
						<c-link v-if="auth('m_order')" @click="navigateTo(`/order_detail/${data.order_number}`)">{{data.order_number}}</c-link>
						<span v-else>{{data.order_number}}</span>
					</template>
                </c-table-column>

                <c-table-column
                        label="使用用户昵称"
                        name="topic"
                        width="150"
                >
                    <template v-slot="{data}">
                        {{data.nick_name ? data.nick_name : '-'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="核销人"
                        name="handle_user_realname"
                        width="100"
                >
					<template v-slot="{data}">
					    {{data.used_flag==2 ? data.handle_user_realname : '-'}}
					</template>
                </c-table-column>

                <c-table-column
                        label="核销时间"
                        name="use_date"
                        width="120"
                >
					<template v-slot="{data}">
					    {{data.used_flag==2 ? data.use_date : '-'}}
					</template>
                </c-table-column>

                <c-table-column
                        label="券码发放时间"
                        name="create_date"
                        width="140"
                >
                </c-table-column>
				<c-table-column
				        label="券码有效期"
				        name="expire_date"
				        width="140"
				>
					<template v-slot="{data}">
					    <span v-if="data.state==1 || data.state==3">{{data.expire_date}}</span>
						<span v-if="data.state==2 || 4">-</span>
					</template>
				</c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    
    export default {
        components: {
            productInfo
        },
        name: 'm_service_card_record',

        computed: {
            stateText() {
                var state = {};
                this.stateDic.forEach(item => {
                    state[item.value] = item.name;
                });
        
                return state;
            }
        },
        
        data() {
            return {
                stateDic: [
        			{name: '待核销',value: 1},
        			{name: '已核销',value: 2},
        			{name: '已过期',value: 3},
        			{name: '已失效',value: 4}
                ],
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/service/card/record/list',
                    data
                });
            }
        }
    }
</script>